/** Pide al service worker cachear el shell actual (JS/CSS) para F5 offline. */

function looksLikeAppAsset(url) {
    if (!url) return false;
    // Incluye chunks de webpack-dev-server sin extensión clara en query.
    if (/\.(js|css|mjs|woff2?|ttf|otf)(\?|$)/i.test(url)) return true;
    if (/\/js\//i.test(url) || /\/css\//i.test(url)) return true;
    if (/src_views_|src_components_|node_modules_|chunk-|dashboard\.|app\.|vendors~/i.test(url)) {
        return true;
    }
    return false;
}

function collectLoadedAssetUrls() {
    if (typeof window === 'undefined') return [];
    const origin = window.location.origin;
    const urls = new Set();

    document.querySelectorAll('script[src]').forEach((el) => {
        if (el.src && el.src.startsWith(origin) && looksLikeAppAsset(el.src)) {
            urls.add(el.src);
        }
    });
    document.querySelectorAll('link[rel="stylesheet"][href]').forEach((el) => {
        if (el.href && el.href.startsWith(origin)) urls.add(el.href);
    });
    document.querySelectorAll('link[rel="prefetch"][href], link[rel="preload"][href]').forEach((el) => {
        if (el.href && el.href.startsWith(origin) && looksLikeAppAsset(el.href)) {
            urls.add(el.href);
        }
    });

    if (typeof performance !== 'undefined' && performance.getEntriesByType) {
        performance.getEntriesByType('resource').forEach((entry) => {
            if (!entry.name || !entry.name.startsWith(origin)) return;
            if (!looksLikeAppAsset(entry.name)) return;
            urls.add(entry.name);
        });
    }

    return Array.from(urls);
}

export async function cacheAppShellAssets() {
    if (!('serviceWorker' in navigator)) return;
    try {
        const reg = await navigator.serviceWorker.ready;
        const worker = reg.active || reg.waiting || reg.installing;
        if (!worker) return;
        const urls = collectLoadedAssetUrls();
        if (!urls.length) return;
        worker.postMessage({ type: 'CACHE_URLS', urls });
    } catch (err) {
        console.warn('[sw] cacheAppShellAssets:', err);
    }
}

export function initAppShellCaching() {
    if (typeof window === 'undefined') return;
    const run = () => {
        window.setTimeout(() => {
            void cacheAppShellAssets();
        }, 1500);
    };
    if (document.readyState === 'complete') {
        run();
    } else {
        window.addEventListener('load', run, { once: true });
    }
}
